export { default } from './OfferList' 


// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferList/index.js